// extracted by mini-css-extract-plugin
module.exports = {"loading_background":"login_loading_background__3htjX","loading_img":"login_loading_img__QMfQF","svg":"login_svg__KoHlD"};